import {useEffect} from "react";
import { useWeb3React as useWeb3ReactCore } from "@web3-react/core";
import {injected} from "../connectors";

/**
 * Use for network and injected - logs user in
 * and out after checking what network theyre on
 */
export function useInactiveListener(suppress = false) {
    const { active, error, activate } = useWeb3ReactCore();
    useEffect(() => {
        const { ethereum } = window;

        if (ethereum && ethereum.on && !active && !error && !suppress) {
            const handleChainChanged = () => {
                window.location.reload();
                // eat errors
                activate(injected, undefined, true).catch((error) => {
                    console.error("Failed to activate after chain changed", error);
                });
            };

            const handleAccountsChanged = (accounts) => {
                if (accounts.length > 0) {
                    // eat errors
                    activate(injected, undefined, true).catch((error) => {
                        console.error("Failed to activate after accounts changed", error);
                    });
                }
            };

            ethereum.on("chainChanged", handleChainChanged);
            ethereum.on("accountsChanged", handleAccountsChanged);

            return () => {
                if (ethereum.removeListener) {
                    ethereum.removeListener("chainChanged", handleChainChanged);
                    ethereum.removeListener("accountsChanged", handleAccountsChanged);
                }
            };
        }
        return undefined;
    }, [active, error, suppress, activate]);
}
